'use client';

import { CHAT_LABELS } from '@/app/lib/guideChat/labels';
import type { PhoneCta } from '@/app/lib/guideChat/types';

export function phoneCtaOf(value: unknown): PhoneCta | null {
  if (!value || typeof value !== 'object') return null;
  const cta = value as Partial<PhoneCta>;
  if (typeof cta.number !== 'string' || typeof cta.label !== 'string' || typeof cta.href !== 'string') return null;
  // Only a dialable link is rendered: the payload never gets to inject another scheme.
  return /^tel:\+?[\d.\s-]+$/.test(cta.href) ? (cta as PhoneCta) : null;
}

export default function PhoneCtaLink({ cta }: { cta: PhoneCta }) {
  return (
    <a
      href={cta.href}
      aria-label={`${CHAT_LABELS.phoneCtaAria} ${cta.number}`}
      className="inline-flex max-w-[92%] items-center gap-2 rounded-lg bg-rm-orange px-3 py-1.5 text-sm font-bold text-white hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-rm-blue-deep"
    >
      <i aria-hidden="true" className="fa-regular fa-phone" />
      <span>{cta.label}</span>
      <span className="font-semibold">{cta.number}</span>
    </a>
  );
}
